export const getPager = state => state.pager
export const getQuotes = state => state.quotes
export const getAuthors = state => state.authors
export const getOrders = state => state.orders
export const getActiveQuote = state => state.activeQuote
export const getChangeQuotes = state => state.changeQuotes
export const getMe = state => state.me
export const getKaleiders = state => state.kaleiders
export const getFiltersVisibility = state => state.filterVisibility



// WEBPACK FOOTER //
// ./src/vuex/getters.js